// main
import ContentFormatXX from '../content/webz/content-format-xx';
import WebbDividerSmall from '../content/webx/webb-divider-sm';
import WebbDividerMedium from '../content/webx/webb-divider-md';

import { UserForm } from '../services/srvc-utilities';

import ChannelsCreateModule from '../content/channels/channels-create';

export default function ChannelsCreate() {
  


  return (
    <ContentFormatXX 
      head = {'Create Channel'}
      home = {`/`}
      link = {`/${UserForm()}/home`}
      form = {'mini'}
      data = {
        <>
          <WebbDividerSmall />
          <ChannelsCreateModule />
          
        </>
        
      }  
    /> 
  )
}